import { Styles } from './styles';

export const defaultStyles: Styles = {
  control: {
    root: 'flex flex-col control default-mb',
    wrapper: 'wrapper',
    label: 'title3-bold mb-6',
    description: 'description',
    input: 'input',
    error: 'text-negative-500',
    textarea: '',
    select: 'select',
    option: 'option',
    'date-time': 'date-time-input body1 q-py-sm',
  },
  verticalLayout: {
    root: 'vertical-layout',
    item: 'vertical-layout-item',
  },
  horizontalLayout: {
    root: 'horizontal-layout',
    item: 'horizontal-layout-item',
  },
  group: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
  },
  arrayList: {
    root: 'array-list',
    legend: 'array-list-legend',
    addButton: 'array-list-add',
    label: 'array-list-label',
    itemWrapper: 'array-list-item-wrapper',
    noData: 'array-list-no-data',
    item: 'array-list-item',
    itemToolbar: 'array-list-item-toolbar',
    itemLabel: 'array-list-item-label',
    itemContent: 'array-list-item-content',
    itemExpanded: 'expanded',
    itemMoveUp: 'array-list-item-move-up',
    itemMoveDown: 'array-list-item-move-down',
    itemDelete: 'array-list-item-delete',
  },
  label: {
    root: 'label-element',
  },
  dialog: {
    root: 'dialog-root',
    title: 'dialog-title',
    body: 'dialog-body',
    actions: 'dialog-actions',
    buttonPrimary: 'dialog-button-primary',
    buttonSecondary: 'dialog-button-secondary',
  },
};
